<div class="route-component">
    <div class="form-component">

        <tab-control>
            <tab-page title="Data Status Report" icon="fas fa-user-pen">
                <h4>
                    Input Report Parameters
                </h4>

                <form #form="ngForm" (ngSubmit)="onRunReport(form)">
                    <!-- Period -->
                    <div class="input-group">
                        <auto-complete-dropdown
                            [options]="periods"
                            [label]="'Period'"
                            [placeholder]="'Select a period...'"
                            [initialValue]="selectedPeriodId"
                            [required]="true"
                            [invalid]="!selectedPeriodId && formSubmitted"
                            [validationMessage]="'Period is required'"
                            [displayWith]="displayPeriod"
                            (selectionChange)="onPeriodSelectionChange($event)">
                        </auto-complete-dropdown>
                    </div>

                    <!-- Client -->
                    <div class="input-group">
                        <auto-complete-dropdown
                            [options]="clients"
                            [label]="'Client'"
                            [placeholder]="'Select a client...'"
                            [initialValue]="selectedClientId"
                            [required]="true"
                            [invalid]="!selectedClientId && formSubmitted"
                            [validationMessage]="'Client is required'"
                            (selectionChange)="onClientSelectionChange($event)">
                        </auto-complete-dropdown>
                    </div>

                    <!-- Policy -->
                    <div class="input-group" *ngIf="selectedClientId && clientAreas && clientAreas.length">
                        <auto-complete-dropdown
                            [options]="clientAreas"
                            [label]="'Client Area'"
                            [placeholder]="'Select a client area...'"
                            [initialValue]="selectedClientAreaId"
                            [required]="true"
                            [invalid]="!selectedClientAreaId && formSubmitted"
                            [validationMessage]="'Client Area is required'"
                            (selectionChange)="onClientAreaSelectionChange($event)">
                        </auto-complete-dropdown>
                    </div>

                    <!-- Action Bar -->
                    <div class="action-bar">
                        <button type="submit" class="button" [disabled]="form.invalid">
                            <i class="fas fa-fire"></i>
                            Run Report
                        </button>
                    </div>
                </form>
            </tab-page>
        </tab-control>

    </div>
</div>